import { http } from '@/services/http'
import queryBuilder from '@/services/queryBuilder'

const parseData = (date) => {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
}

const getAll = ({ state, commit }, method) => {
  commit('PENDING', true)
  return new Promise((resolve, reject) => {
    const query = {
      query: queryBuilder.buildQuery({
        summary: {
          calculations: [ 'started', 'completed', 'phone_confirmed', 'sold_policies' ],
          payments: { 'saldo': true, 'payout_possibility': { 'from': 'payoff_possibility' } }
        }
      })
    }

    let requestQuery = query
    if (method === 'get') requestQuery = { params: requestQuery }

    http[method]('/api/graphql', requestQuery)
      .then((response) => {
        commit('SAVE_SUMMARY', response.data)
        resolve(response)
      })
      .catch((error) => {
        commit('PENDING', false)
        reject(error.response.data)
      })
  })
}
const getPaymentSaldo = ({ state, commit }, method) => {
  return new Promise((resolve, reject) => {
    const query = {
      query: queryBuilder.buildQuery({
        summary: {
          payments: { 'saldo': true, 'payout_possibility': { 'from': 'payoff_possibility' } }
        }
      })
    }

    let requestQuery = query
    if (method === 'get') requestQuery = { params: requestQuery }

    http[method]('/api/graphql', requestQuery)
      .then((response) => {
        commit('SAVE_SALDO', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error.response.data)
      })
  })
}

const getCalculationHistory = ({ state, commit }, method) => {
  commit('PENDING_HISTORY', true)
  return new Promise((resolve, reject) => {
    let currentDate = new Date()
    let fromDate = new Date(currentDate - 10 * 24 * 3600 * 1000)
    const query = {
      query: queryBuilder.buildQuery({
        history: {
          where: {
            date_from: `"${parseData(fromDate)}"`,
            date_to: `"${parseData(currentDate)}"`
          },
          select: {
            calculations: {
              started: true,
              completed: true,
              date: true
            }
          }
        }
      })
    }

    let requestQuery = query
    if (method === 'get') requestQuery = { params: requestQuery }

    http[method]('/api/graphql', requestQuery)
      .then((response) => {
        commit('SAVE_HISTORY', response.data)
        resolve(response)
      })
      .catch((error) => {
        commit('PENDING_HISTORY', false)
        reject(error.response.data)
      })
  })
}

export default {
  getAll,
  getPaymentSaldo,
  getCalculationHistory
}



// WEBPACK FOOTER //
// ./src/store/modules/statistics/actions.js